import { baseWindowStyles } from "../../styles/styles";

import logo from "../../images/fibabanka-logo.png";
import React from "react";
import AlertComponent from "./Alert";
import {
  Grid,
  Paper,
  Box,
  Container,
  BottomNavigation,
  CardActions,
} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Basket from "./Basket";

export default function BaseWindow(props) {
  const classes = baseWindowStyles();

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper} style={{position:'relative'}}>
        
        <div style = {{position:'relative'}}>
          <img alt="Fibabanka" src={logo} width={100} height={25} />
          {props.isBasket && <Basket header={props.basketHeader} content={props.basketContent} />}
        </div>
        
        <Grid
          container
          direction="column"
          item
          className={props.isBasket ? classes.baseGrid : classes.baseGridWhBasket}
        >
          
          {props.children}
        </Grid>
        <AlertComponent />
      </Paper>
    </Box>
  );
}
